import { css } from "@emotion/css";
import MuiTabs from "@mui/material/Tabs";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import React from "react";
export interface TabsProps {
    value: string;
    onChange: (event: React.ChangeEvent<object>, value: string) => void;
    variant: "scrollable" | "fullWidth";
    scrollButtons?: "auto";
    children: React.ReactNode;
}
export function Tabs({ value, onChange, variant, scrollButtons, children }: TabsProps) {
    return (<MuiTabs classes={{ root: tabsRootStyles, indicator: tabsIndicatorStyles }} value={value} onChange={onChange} variant={variant} scrollButtons={scrollButtons}>
            {children}
        </MuiTabs>);
}
const muiTabsClasses = {
    root: "MuiTabs-root",
    indicator: "MuiTabs-indicator",
};
const tabsRootStyles = css({
    [`&.${muiTabsClasses.root}`]: {
        color: themeTokens.color.text.secondary,
        width: "100%",
    },
});
const tabsIndicatorStyles = css({
    [`&.${muiTabsClasses.indicator}`]: {
        backgroundColor: themeTokens.color.text.selected,
    },
});
